import { render } from "./affiliate-review-page-questions.vue?vue&type=template&id=95b224ae&scoped=true&ts=true"
import script from "./affiliate-review-page-questions.vue?vue&type=script&lang=ts"
export * from "./affiliate-review-page-questions.vue?vue&type=script&lang=ts"

import "./affiliate-review-page-questions.vue?vue&type=style&index=0&id=95b224ae&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b224ae"]])

export default __exports__